/* Home: greeting, composer (starts a chat), starters, waiting items, daily brief and Discover teaser.
   Shares the chat feature's backend (features/chat/runtime.ts). */
import { lazy } from 'react';
import { House } from 'lucide-react';
import { defineFeature } from '../../app/feature';

export default defineFeature({
  id: 'home',
  title: 'Home',
  short: 'Home',
  icon: House,
  group: 'Work',
  route: '/home',
  order: 0,
  rail: true,
  bottom: true,
  screen: lazy(() => import('./Screen.tsx')),
  commands: [{ id: 'open', title: 'Go home', to: '/home', keywords: ['start', 'greeting', 'brief'] }],
  capabilities: ['CHAT-02', 'CHAT-07', 'MODEL-02', 'MODEL-04', 'SAFE-01'],
});
